import { useState } from "react";
import AdminCard from "./AdminCard";

interface Props { onSave: () => void; }

export default function AdminFooter({ onSave }: Props) {
  const [brand, setBrand] = useState({
    name: "Thorpe Dellow",
    tagline: "Structured Investments",
    description: "Specialist social housing investment products backed by UK assisted living assets. Targeting 10.00% p.a. for qualified investors.",
  });

  const [navLinks, setNavLinks] = useState([
    { id: 1, label: "Home", path: "/" },
    { id: 2, label: "Properties", path: "/properties" },
    { id: 3, label: "Social Housing", path: "/social-housing" },
    { id: 4, label: "About Us", path: "/about" },
    { id: 5, label: "Contact", path: "/contact" },
    { id: 6, label: "Investment Brochure", path: "/brochure" },
  ]);

  const [productLinks, setProductLinks] = useState([
    { id: 1, label: "Social Housing Product", path: "/social-housing" },
    { id: 2, label: "NASDAQ Dubai Bonds", path: "/contact" },
    { id: 3, label: "Express Interest", path: "/social-housing#apply" },
    { id: 4, label: "Investment Brochure", path: "/brochure" },
  ]);

  const [legalLinks, setLegalLinks] = useState([
    { id: 1, label: "Privacy Policy", path: "/privacy-policy" },
    { id: 2, label: "Terms of Use", path: "/terms-of-use" },
    { id: 3, label: "Risk Disclaimer", path: "/risk-disclaimer" },
  ]);

  const [regulatory, setRegulatory] = useState(
    "Thorpe Property Development Ltd (Company No. 07590563), trading as Thorpe Dellow. Registered in England and Wales. Registered office: One Embankment, Leeds LS1 4DW, United Kingdom. This website and all financial promotions are issued in accordance with Section 21 of the Financial Services and Markets Act 2000 (FSMA). All content is directed solely at Certified High Net Worth Individuals, Self-Certified Sophisticated Investors, or eligible retail investors. Investments are speculative and involve risk. Investors may lose some or all of their capital. Past performance is not indicative of future results."
  );

  const [copyright, setCopyright] = useState("© 2026 Thorpe Dellow. All rights reserved.");

  const updateNavLink = (id: number, k: string, v: string) =>
    setNavLinks((prev) => prev.map((l) => l.id === id ? { ...l, [k]: v } : l));
  const updateProductLink = (id: number, k: string, v: string) =>
    setProductLinks((prev) => prev.map((l) => l.id === id ? { ...l, [k]: v } : l));
  const updateLegalLink = (id: number, k: string, v: string) =>
    setLegalLinks((prev) => prev.map((l) => l.id === id ? { ...l, [k]: v } : l));

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-[#071A2E]" style={{ fontFamily: "'Playfair Display', serif" }}>Footer</h1>
        <p className="text-slate-500 text-sm mt-1">Manage footer brand text, navigation links, product links, legal links, and regulatory disclaimer.</p>
      </div>

      <AdminCard title="Brand Block">
        <div className="space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-semibold text-slate-600 mb-1.5">Brand Name</label>
              <input value={brand.name} onChange={(e) => setBrand({ ...brand, name: e.target.value })} className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C9A84C]" />
            </div>
            <div>
              <label className="block text-xs font-semibold text-slate-600 mb-1.5">Tagline</label>
              <input value={brand.tagline} onChange={(e) => setBrand({ ...brand, tagline: e.target.value })} className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C9A84C]" />
            </div>
          </div>
          <div>
            <label className="block text-xs font-semibold text-slate-600 mb-1.5">Brand Description</label>
            <textarea value={brand.description} onChange={(e) => setBrand({ ...brand, description: e.target.value })} rows={2} className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C9A84C] resize-none" />
          </div>
        </div>
      </AdminCard>

      <AdminCard title="Navigation Links">
        <div className="space-y-3">
          {navLinks.map((l) => (
            <div key={l.id} className="grid grid-cols-2 gap-3 bg-slate-50 rounded-xl p-3 border border-slate-100">
              <div>
                <label className="block text-xs font-semibold text-slate-600 mb-1">Label</label>
                <input value={l.label} onChange={(e) => updateNavLink(l.id, "label", e.target.value)} className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#C9A84C]" />
              </div>
              <div>
                <label className="block text-xs font-semibold text-slate-600 mb-1">Path</label>
                <input value={l.path} onChange={(e) => updateNavLink(l.id, "path", e.target.value)} className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#C9A84C] font-mono" />
              </div>
            </div>
          ))}
        </div>
      </AdminCard>

      <AdminCard title="Products Links">
        <div className="space-y-3">
          {productLinks.map((l) => (
            <div key={l.id} className="grid grid-cols-2 gap-3 bg-slate-50 rounded-xl p-3 border border-slate-100">
              <div>
                <label className="block text-xs font-semibold text-slate-600 mb-1">Label</label>
                <input value={l.label} onChange={(e) => updateProductLink(l.id, "label", e.target.value)} className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#C9A84C]" />
              </div>
              <div>
                <label className="block text-xs font-semibold text-slate-600 mb-1">Path</label>
                <input value={l.path} onChange={(e) => updateProductLink(l.id, "path", e.target.value)} className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#C9A84C] font-mono" />
              </div>
            </div>
          ))}
        </div>
      </AdminCard>

      <AdminCard title="Legal Links (Bottom Bar)">
        <div className="space-y-3">
          {legalLinks.map((l) => (
            <div key={l.id} className="grid grid-cols-2 gap-3 bg-slate-50 rounded-xl p-3 border border-slate-100">
              <div>
                <label className="block text-xs font-semibold text-slate-600 mb-1">Label</label>
                <input value={l.label} onChange={(e) => updateLegalLink(l.id, "label", e.target.value)} className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#C9A84C]" />
              </div>
              <div>
                <label className="block text-xs font-semibold text-slate-600 mb-1">Path</label>
                <input value={l.path} onChange={(e) => updateLegalLink(l.id, "path", e.target.value)} className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#C9A84C] font-mono" />
              </div>
            </div>
          ))}
        </div>
      </AdminCard>

      <AdminCard title="Copyright Text">
        <div>
          <label className="block text-xs font-semibold text-slate-600 mb-1.5">Copyright Line</label>
          <input value={copyright} onChange={(e) => setCopyright(e.target.value)} className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C9A84C]" />
        </div>
      </AdminCard>

      <AdminCard title="Regulatory Disclaimer">
        <div>
          <label className="block text-xs font-semibold text-slate-600 mb-1.5">Full Regulatory Notice Text</label>
          <textarea value={regulatory} onChange={(e) => setRegulatory(e.target.value)} rows={6} className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C9A84C] resize-none" />
          <p className="text-xs text-slate-400 mt-1.5">This appears in the footer above the copyright bar.</p>
        </div>
      </AdminCard>

      <div className="flex justify-end">
        <button onClick={onSave} className="flex items-center gap-2 px-6 py-3 rounded-xl bg-[#071A2E] text-white text-sm font-semibold hover:bg-[#0D2B4A] transition-colors cursor-pointer whitespace-nowrap">
          <i className="ri-save-line leading-none" />
          Save Changes
        </button>
      </div>
    </div>
  );
}
